import { useSelector } from 'react-redux';
import translation from '../../languages';
import { MaterialType } from '../../types/material-page';
import getLabel from '../../utils/material/get-label';
import { MATERIAL_LABELS } from '../../utils/material/material-labels.constants';
import showQualityBadge from '../../utils/material/show-quality-badge';
import discountPercent from '../../utils/sale/discount-percent';
import MaterialLabel from '../material-label/material-label';
import QualityBadge from '../quality-badge/quality-badge';
import './label.scss';

type LabelProps = TranslationProps & { item: Material };

const Label = (props: LabelProps) => {
    const { item, t } = props;

    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);
    const label = getLabel(item, countryCode);

    return (
        <>
            {label === MATERIAL_LABELS.DONATE && (
                <div className='donate label'>
                    {t('common.label.donate')}
                    <div className='triangle' />
                </div>
            )}
            {label === MATERIAL_LABELS.SALE && item.sale?.original_price && (
                <MaterialLabel variant='red'>−{discountPercent(item.sale.original_price, item.price)}%</MaterialLabel>
            )}
            {showQualityBadge(item) && label === MATERIAL_LABELS.HIGH_QUALITY && (
                <QualityBadge noIcon noTooltip material={item as unknown as MaterialType} />
            )}
            {label === MATERIAL_LABELS.BESTSELLER && <MaterialLabel variant='yellow'>Bestseller</MaterialLabel>}
            {label === MATERIAL_LABELS.NEW && <MaterialLabel variant='cyan'>{t('common.label.new')}</MaterialLabel>}
        </>
    );
};

const translate = translation('common');

export default translate(Label);
